import { Navigate, Route, Routes } from "react-router";

import useRefreshedUsagePageFlag from "shared/Usage/useRefreshedPageFlag";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import UsageRunMinutes from "./RunMinutes";
import UsageRunMinutesNew from "./RunMinutes/New";
import UsageWorkers from "./Workers";
import UsageWorkersNew from "./Workers/New";

const Usage = () => {
  const { accountName } = useTypedContext(AccountContext);
  const isRefreshedUsagePageEnabled = useRefreshedUsagePageFlag();

  useTitle(`Organization Settings · Usage · ${accountName}`);

  return (
    <Routes>
      <Route index element={<Navigate to="workers" replace />} />
      <Route
        path="runs"
        element={isRefreshedUsagePageEnabled ? <UsageRunMinutesNew /> : <UsageRunMinutes />}
      />
      <Route
        path="workers"
        element={isRefreshedUsagePageEnabled ? <UsageWorkersNew /> : <UsageWorkers />}
      />
    </Routes>
  );
};

export default Usage;
